import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import useCallContextStore from "@/stores/useCallContextStore"

export const ButtonContinueInboundCall = () => {
  const callId = useCallContextStore((state) => state.callID)
  const pushedUrl = useCallContextStore((state) => state.pushedUrl)
  const { t } = useTranslation()

  const continueInboundCall = () => {
    window.location.href = pushedUrl
  }

  if (!callId) return null

  return (
    <Button variant="tertiary" onClick={continueInboundCall} data-testid="continue-ibc-button">
      {t("patient.ibc.banner.buttonContinue")}
    </Button>
  )
}
